import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    // Clear fragment so session_id is never reused
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    loginWithGoogle(sessionId)
      .then((u) => {
        toast.success("Bienvenido");
        navigate(u?.is_super_admin ? "/admin-panel" : "/app/dashboard", { replace: true });
      })
      .catch((err) => {
        const detail = err?.response?.data?.detail || "No se pudo iniciar sesion con Google";
        toast.error(detail);
        navigate("/login", { replace: true });
      });
  }, [loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090B] text-[#71717A] text-sm" data-testid="auth-callback-loading">
      Iniciando sesion con Google...
    </div>
  );
}
